import { ApplicationError } from "@/error/ApplicationError";
import type { UnknownRecord } from "@/utils/type";

export class DataError extends ApplicationError {
  constructor(message: string, data: UnknownRecord) {
    super("DataError", message, { data });
  }
}
